// extracted by mini-css-extract-plugin
export var actionContainer = "index-module--actionContainer--s2EWE";
export var actionContent = "index-module--actionContent--8P4KZ";
export var actionTitle = "index-module--actionTitle--v+FoL";
export var actionsWrapper = "index-module--actionsWrapper--VAJsD";